export { default } from "./AuthorContainer";
